import React, { useState } from "react";
import { Drawer, Button, Box, Typography } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export default function BottomSheetPopup({ open, close, data, onApprove }) {

    const formatDate = (mongoDate) => {
        const date = new Date(mongoDate); // MongoDB gives ISO string or Date object
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

        const formatDateTime = (mongoDate) => {
        const date = new Date(mongoDate); // MongoDB gives ISO string or Date object
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    return (
        <div>
            <Drawer
                anchor="bottom"
                open={open}
                onClose={() => close()}
                PaperProps={{
                    sx: {
                        borderTopLeftRadius: "30px",
                        borderTopRightRadius: "30px",
                        paddingTop: 3,
                        paddingBottom: "5px",
                        paddingInline: 2.5
                    },
                }}
            >
                <Box sx={{ background: "#ffffff" }}>
                    <Box sx={{ flexDirection: 'row', alignItems: 'center', display: 'flex', gap: "5px" }}>
                        <ArrowBack onClick={() => close()} style={{ color: "#303030", cursor: 'pointer', padding: "5px", width: "35px", height: "35px" }} />
                        <Typography style={{ fontFamily: "poppins", fontSize: "16px", fontWeight: 600, color: "#303030" }} >Ticket Details</Typography>
                    </Box>

                    <Box sx={{
                        background: "#ffffff", border: "10px solid #aaaaaa20", alignSelf: 'stretch', flexDirection: 'column',
                        display: 'flex', borderRadius: "30px", padding: 2, marginTop: "20px"
                    }}>

                        <Box sx={{
                            display: 'flex', borderRadius: "20px", background: '#000000', alignItems: 'center', justifyContent: 'center',
                            flexDirection: 'column',
                            paddingBlock: "35px"
                        }}>

                            <Typography style={{
                                fontFamily: "poppins", fontSize: "19px", color: "#ffffff", fontWeight: 600,
                                letterSpacing: "3px"
                            }}>{data.ticketNumber || "-"}</Typography>

                        </Box>

                        <Box sx={{ background: "#aaaaaa20", height: "1px", alignSelf: 'stretch', marginTop: "20px" }} />

                        <Box sx={{ flexDirection: 'column', display: 'flex', alignSelf: "stretch", marginTop: "15px" }} >

                            <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Full Name</Typography>
                            <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: "#303030", fontWeight: 500 }} >{data.user ? data.user.full_name : "-"}</Typography>

                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', marginTop: "15px" }}>

                            <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }} >

                                <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Username</Typography>
                                <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: "#303030", fontWeight: 500 }} >{data.user ? data.user.buzz_name : "-"}</Typography>

                            </Box>

                            <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }} >

                                <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Issue Date</Typography>
                                <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: "#303030", fontWeight: 500 }} >{data.createdAt ? formatDate(data.createdAt) : "-"}</Typography>

                            </Box>

                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', marginTop: "15px" }}>

                            <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }} >

                                <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Ticket Name</Typography>
                                <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: "#303030", fontWeight: 500 }} >{data.ticket ? data.ticket.name ? data.ticket.name : "Entry Ticket" : "-"}</Typography>

                            </Box>

                            <Box sx={{ flexDirection: 'column', display: 'flex', flex: 1 }} >

                                <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Status</Typography>
                                <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: data.isRedeemed ? "#ff8800" : "#00a100ff", fontWeight: 500 }} >{data.isRedeemed ? "Redeemed" : "Waiting"}</Typography>

                            </Box>

                        </Box>

                        <Box sx={{ flexDirection: 'column', display: 'flex', alignSelf: "stretch", marginTop: "15px" }} >

                            <Typography style={{ fontFamily: "poppins", fontSize: "13px", color: "#707070" }} >Total Amount Paid</Typography>
                            <Typography style={{ fontFamily: "poppins", fontSize: "14px", color: "#303030", fontWeight: 500 }} >₹{Number(data.ticket ? data.ticket.price : 0).toFixed(2)}</Typography>

                        </Box>

                        <Box sx={{ background: "#aaaaaa20", height: "1px", alignSelf: 'stretch', marginTop: "10px" }} />

                        <Typography style={{
                            fontFamily: "poppins",
                            fontSize: "13px",
                            color: data.isRedeemed ? "#ff8800" : "#00a100",
                            fontWeight: 500,
                            background: data.isRedeemed ? "#ff880020" : "#00a10020",
                            alignSelf: 'stretch',
                            paddingInline: "20px",
                            paddingBlock: "15px",
                            marginTop: "10px",
                            borderRadius: "20px"
                        }}>{data.isRedeemed ? `This ticket is valid and already redeemed${data.redeemedAt ? ` on ${formatDateTime(data.redeemedAt)}` : "."}` : "This is a valid ticket."}</Typography>


                    </Box>

                    <Button
                        variant="contained"
                        fullWidth
                        sx={{
                            mt: 2, borderRadius: 100, paddingBlock: "15px", fontFamily: "poppins", fontSize: "14px", textTransform: 'none',
                            background: data.isRedeemed ? "#aaaaaa40" : "#000000", color: data.isRedeemed ? "#aaaaaa" : "#ffffff"
                        }}
                        onClick={() => {
                            if (data.isRedeemed) {

                            } else {
                                onApprove()
                            }
                        }}>
                        {
                            data.isRedeemed ? "Redeemed" : "Approve Ticket"
                        }
                    </Button>
                </Box>
            </Drawer>
        </div>
    );
}
